export default "__VITE_ASSET__239a0994__"